var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-table-container" },
    [
      _vm.isBailianFlag
        ? _c("p", { staticClass: "required-remark" }, [
            _c("span", { staticClass: "require-icon" }, [_vm._v("*")]),
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.type === "edit"
                    ? _vm.$t("storeVisitReport.SSTable.msg1")
                    : ""
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          class: { "error-table": _vm.hasErrorTable },
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            "show-summary": "",
            "summary-method": _vm.getSummaries,
            data: _vm.list,
            "highlight-current-row": "",
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              index: _vm.tableIndex,
              label: _vm.$t("retailStoresInfo.form.otherBrandSales.systemPk"),
              width: "120",
              align: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("retailStoresInfo.form.otherBrandSales.brand"),
              width: "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { class: scope.$index < 7 ? "required" : "" }, [
                      _vm._v(
                        _vm._s(
                          (_vm.lookupList["TYRE_BRAND_MAPPING"] &&
                            _vm.lookupList["TYRE_BRAND_MAPPING"][
                              scope.row.tireBrand
                            ]) ||
                            scope.row.tireBrand
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t(
                "retailStoresInfo.form.otherBrandSales.tireSupplier"
              ),
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          rules: scope.$index < 7 ? _vm.rules.isEmpty : [],
                          prop:
                            "tireSalesInfos." + scope.$index + ".tireSupplier",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              value: scope.row.tireSupplier,
                              disabled: _vm.type !== "edit",
                              placeholder:
                                _vm.type !== "edit"
                                  ? ""
                                  : _vm.$t("messagePush.input.optionHolder"),
                              clearable: "",
                            },
                            on: {
                              change: function (v) {
                                return _vm.updateFormValue(
                                  v,
                                  "tireSupplier",
                                  scope.row
                                )
                              },
                            },
                          },
                          _vm._l(
                            _vm.lookupList["TIRE_SUPPLIER"],
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.code },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t(
                "retailStoresInfo.form.otherBrandSales.paymentTerms"
              ),
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          rules: scope.$index < 7 ? _vm.rules.isEmpty : [],
                          prop:
                            "tireSalesInfos." + scope.$index + ".paymentTerms",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              value: scope.row.paymentTerms,
                              disabled: _vm.type !== "edit",
                              placeholder:
                                _vm.type !== "edit"
                                  ? ""
                                  : _vm.$t("messagePush.input.optionHolder"),
                              clearable: "",
                            },
                            on: {
                              change: function (v) {
                                return _vm.updateFormValue(
                                  v,
                                  "paymentTerms",
                                  scope.row
                                )
                              },
                            },
                          },
                          _vm._l(
                            _vm.lookupList["ACCOUNTING_METHOD"],
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.code },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "monthlyAvgSales",
              label: _vm.$t(
                "retailStoresInfo.form.otherBrandSales.monthlyAvgSales"
              ),
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          rules: scope.$index < 7 ? _vm.rules.isEmpty : [],
                          prop:
                            "tireSalesInfos." +
                            scope.$index +
                            ".monthlyAvgSales",
                        },
                      },
                      [
                        _c("FormInputNumber", {
                          attrs: {
                            val: scope.row.monthlyAvgSales,
                            step: 1,
                            mode: _vm.type,
                          },
                          on: {
                            "update:val": function (v) {
                              return _vm.updateFormValue(
                                v,
                                "monthlyAvgSales",
                                scope.row
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "stock",
              label: _vm.$t("retailStoresInfo.form.otherBrandSales.stock"),
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          rules: scope.$index < 7 ? _vm.rules.isEmpty : [],
                          prop: "tireSalesInfos." + scope.$index + ".stock",
                        },
                      },
                      [
                        _c("FormInputNumber", {
                          attrs: {
                            val: scope.row.stock,
                            step: 1,
                            mode: _vm.type,
                          },
                          on: {
                            "update:val": function (v) {
                              return _vm.updateFormValue(v, "stock", scope.row)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }